export default __webpack_public_path__ + "static/media/helm.e920d285.svg";